export default {"src":"/_next/static/media/filled-star.c051d42b.svg","height":33,"width":33,"blurWidth":0,"blurHeight":0};